<!-- =========================================================================================
  File Name: activity.vue
  Description: Setting Activity
========================================================================================== -->

<template>
  <div id="setting-activity">

    <vx-card title="活动设置">
      <vs-table stripe :data="list">
        <template slot="thead">
          <vs-th width="150">ID</vs-th>
          <vs-th width="400">标题</vs-th>
          <vs-th>开始时间</vs-th>
          <vs-th>结束时间</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.title">{{item.title}}</vs-td>
            <vs-td :data="item.startDate">{{item.startDate}}</vs-td>
            <vs-td :data="item.endDate">{{item.endDate}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" title="编辑活动" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.title" label-placeholder="活动标题" />
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.isShow" label="前端是否显示">
            <vs-select-item value="1" text="显示" />
            <vs-select-item value="0" text="隐藏" />
          </vs-select>
        </div>
        <div class="vx-row mb-10">
          <div class="vx-col sm:w-1/2 w-full">
            <div class="text-grey text-sm">开始时间</div>
            <flat-pickr v-model="modifyItem.startDate" :config="flatPickrConfig" class="flatpickr-input w-full"></flat-pickr>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div class="text-grey text-sm">结束时间</div>
            <flat-pickr v-model="modifyItem.endDate" :config="flatPickrConfig" class="flatpickr-input w-full"></flat-pickr>
          </div>
        </div>

        <gift-card v-if="modifyItem.shortname === 'giftCard'" :data="modifyItem.params" ref="activityComponent" />
        <gift-recharge v-else-if="modifyItem.shortname === 'giftRecharge'" :data="modifyItem.params" ref="activityComponent" />
        <gift-recharge-once v-else-if="modifyItem.shortname === 'giftRechargeOnce'" :data="modifyItem.params" ref="activityComponent" />
        <score v-else-if="modifyItem.shortname === 'score'" :data="modifyItem.params" ref="activityComponent" />
        <salary v-else-if="modifyItem.shortname === 'salary'" :data="modifyItem.params" ref="activityComponent" />
        <salary-advance v-else-if="modifyItem.shortname === 'salaryAdvance'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <salary-unique v-else-if="modifyItem.shortname === 'salaryUnique'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <salary-hour-unique v-else-if="modifyItem.shortname === 'salaryHourUnique'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <salary-hour-advance v-else-if="modifyItem.shortname === 'salaryHourAdvance'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus v-else-if="modifyItem.shortname === 'bonus'" :data="modifyItem.params" ref="activityComponent" />
        <bonus-advance v-else-if="modifyItem.shortname === 'bonusAdvance'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus-unique v-else-if="modifyItem.shortname === 'bonusUnique'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus-day-unique v-else-if="modifyItem.shortname === 'bonusDayUnique'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus-day-advance v-else-if="modifyItem.shortname === 'bonusDayAdvance'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus-day-unique-fixed v-else-if="modifyItem.shortname === 'bonusDayUniqueFixed'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <bonus-day-advance-fixed v-else-if="modifyItem.shortname === 'bonusDayAdvanceFixed'" :data="modifyItem.params" :groupList="groupList" ref="activityComponent" />
        <game-backwater v-else-if="modifyItem.shortname === 'gameBackwater'" :data="modifyItem.params" ref="activityComponent" />

      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'
import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

import giftCard from '../../layouts/components/activity/giftCard.vue'
import giftRecharge from '../../layouts/components/activity/giftRecharge.vue'
import giftRechargeOnce from '../../layouts/components/activity/giftRechargeOnce.vue'
import score from '../../layouts/components/activity/score.vue'
import salary from '../../layouts/components/activity/salary.vue'
import salaryAdvance from '../../layouts/components/activity/salaryAdvance.vue'
import salaryUnique from '../../layouts/components/activity/salaryUnique.vue'
import salaryHourUnique from '../../layouts/components/activity/salaryHourUnique.vue'
import salaryHourAdvance from '../../layouts/components/activity/salaryHourAdvance.vue'
import bonus from '../../layouts/components/activity/bonus.vue'
import bonusAdvance from '../../layouts/components/activity/bonusAdvance.vue'
import bonusUnique from '../../layouts/components/activity/bonusUnique.vue'
import bonusDayUnique from '../../layouts/components/activity/bonusDayUnique.vue'
import bonusDayAdvance from '../../layouts/components/activity/bonusDayAdvance.vue'
import bonusDayUniqueFixed from '../../layouts/components/activity/bonusDayUniqueFixed.vue'
import bonusDayAdvanceFixed from '../../layouts/components/activity/bonusDayAdvanceFixed.vue'
import gameBackwater from '../../layouts/components/activity/gameBackwater.vue'

export default {
  data() {
    return {
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      flatPickrConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:s',
        locale: flatPickrZh
      },
      groupList: []
    }
  },
  components: {
    modifySiderBar,
    giftCard, giftRecharge, giftRechargeOnce, score,
    salary, salaryAdvance, salaryUnique, salaryHourUnique, salaryHourAdvance,
    bonus, bonusAdvance, bonusUnique, bonusDayUnique, bonusDayAdvance, bonusDayUniqueFixed, bonusDayAdvanceFixed,
    gameBackwater
  },
  methods: {
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.id = this.modifyItem.id
      postdata.title = this.modifyItem.title
      postdata.start = this.modifyItem.startDate
      postdata.end = this.modifyItem.endDate
      postdata.isShow = this.modifyItem.isShow
      postdata.params = this.$refs.activityComponent.getParam()
      this.$utils.post('setting-activityDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.list[this.modifyIndex] = JSON.parse(JSON.stringify(this.modifyItem))
        this.$forceUpdate()
      })
    }
  },
  mounted () {
    // 读取设置
    this.$utils.post('setting-activityList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.list = res
    })

    // 读取用户组
    this.$utils.post('user-groupList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.groupList = res
    })
  }
}
</script>
